import React from 'react';
const MinEditor = (props) => {
    const attribute = Object.assign({}, props);
    const stroke = attribute.stroke || '#7D8085';
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("rect", { width: "16", height: "16", transform: "matrix(-1 0 0 1 16 0)", fill: "none" }),
        React.createElement("path", { d: "M15 6.5L9.50001 6.5L9.5 0.999999", stroke: stroke, fill: "none", strokeWidth: "1.2", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M1 9.5L6.49999 9.5L6.49999 15", stroke: stroke, fill: "none", strokeWidth: "1.2", strokeLinejoin: "round" })));
};
export default MinEditor;
